export default __webpack_public_path__ + "static/media/control-4-white.2177a804.svg";